import type { FaireProductEntity } from "../../entity_types/product";

export const p_ayzy967d4e: FaireProductEntity = {
  token: "p_ayzy967d4e",
  type: "product",
  name: "Hello Pumpkin! - 8oz coconut wax Fall candle",
  brandToken: "b_7utsxh33fh",
  brandName: "Poppy Rose Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/df381bb4f4ad05d65903c58ac15785d42df4e7d49e456ad74b10700db5dcb016.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abafa7e628bd760c7ee50700e99582a0f25ea15f0548f8e153fcd1867c7b0f23.jpeg",
    "https://cdn.faire.com/fastly/5b83d1ee2e7a1a50094ad88d7c24a6f4c61c8672785d8b34c315ae6c195f5f8a.jpeg",
    "https://cdn.faire.com/fastly/025f0b2d359d08c01ec9d750f3cf1e6bf3ee394c3f8907937571ff423ca62e38.jpeg",
  ],
  priceDollars: 11,
  description:
    "Hello, Pumpkin! Rejoice, Autumn lovers—finally a pumpkin candle that isn’t overly sweet and fake smelling. This spicy blend of cinnamon apple, pumpkin butter, and autumn clove is the perfect way to welcome the wondrous change of seasons.\n\n• 8 oz\n• 45 hour burn time\n\nAll of our candles are hand poured with love into sturdy vessels and are made from 100% American grown coconut. They have lead-free cotton wicks and phthalate-free fragrance oils. None of the ingredients or components have ever been tested on animals.\n\nWhat's so great about coconut wax, anyway? We're glad you asked!\n\n• Clean burning: It generally produces less soot than paraffin when paired with our quality wicks and premium fragrance.\n• Excellent scent throw: Coconut wax holds fragrance well and often gives a strong, even scent both when the candle is unlit (cold throw) and burning (hot throw).\n• Longer burn time: It burns more slowly than many other waxes, so candles often last longer.\n• Renewable source: Coconut wax is made from coconut oil, a renewable plant resource.\n• Smooth appearance: It creates a creamy, luxurious finish with fewer frosting issues than soy wax alone.\n• Low melting point: This helps the wax pool evenly, which can improve fragrance release.\n• Biodegradable: Pure coconut wax is biodegradable and easier to clean up with warm, soapy water than paraffin.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:01.138Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
